import React from 'react';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage } from './wsHelpers';
import { connect } from 'react-redux';
import { createAttendee, removeAttendeeFromEvent } from '@/redux/actions';

const WS_EVENTS_BY_HTTP = {
	CREATE_ATTENDEE: 'attendee/POST',
	REMOVE_FROM_EVENT: 'attendee/removeFromEvent/PATCH',
};

const EventAttendeesSubcriptions = props => {
	const { socket, currentEventId, createAttendee, removeAttendeeFromEvent, children } = props;
	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribeToEvent = () => {
		socket.emit('event/:eventID/SUBSCRIBE', { eventID: currentEventId });
		console.log('⚡️ EventSubscriptions Mounted ⚡️');
	};

	const unsubscribeToEvent = () => {
		socket.emit('event/:eventID/UNSUBSCRIBE', { eventID: currentEventId });
		console.log(`🚶‍♂️ EventSubscriptions Unmounted 🚶‍♂️`);
	};

	const listenForCreatedAttendee = () => {
		socket.on(WS_EVENTS_BY_HTTP.CREATE_ATTENDEE, payload => {
			const { data, error } = payload;
			if (error) {
				if (error.response && error.response.errors && error.response.errors.length > 0) {
					const firstError = error.response.errors[0] || {};
					const err = firstError.message;
					if (err.includes('the number of paid seats')) {
						displayMessage('Not enough paid seats. Could not create attendee', err);
					} else {
						displayMessage('Error while creating attendee', err);
					}
				} else {
					displayMessage('Error while creating attendee', error);
				}
			} else {
				createAttendee({ attendee: data });
				displayMessage('Account created');
			}
		});
	};

	const listenForRemovedAttendee = () => {
		socket.on(WS_EVENTS_BY_HTTP.REMOVE_FROM_EVENT, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error while removing attendee', error);
			else {
				const { nodes } = data;
				const attendeeIDs = nodes[0].id;
				removeAttendeeFromEvent({ attendeeIDs });
				displayMessage('User removed from event');
			}
		});
	};

	const listeners = () => [listenForCreatedAttendee, listenForRemovedAttendee];

	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribeToEvent}
				unsub={unsubscribeToEvent}
				listeners={listeners()}
				routes={Object.values(WS_EVENTS_BY_HTTP)}
			/>
			{React.cloneElement(children, propsToSend)}
		</>
	);
};

const msp = ({ ws, auth, events }) => ({
	socket: ws.socket,
	auth0Token: auth.auth0Token,
	currentEventId: events.currentEvent.id,
});

const mdp = dispatch => ({
	createAttendee: attendee => dispatch(createAttendee(attendee)),
	removeAttendeeFromEvent: attendeeID => dispatch(removeAttendeeFromEvent(attendeeID)),
});

export default connect(msp, mdp)(EventAttendeesSubcriptions);
